import axios from 'axios';

import {
    EXPENSE_REIMBURSE_CONST
} from "../actionConstants";
import {
    PATHS, APPLICATION_CONSTANTS
} from '../../AppConstants';
import {
    getCookie,
    saveServerLogs
} from "../../UtilityComponents/Util";
import {
    getAxiosConfig
} from "../../apisSetup/apiConfig";


const axiosApiCaller = getAxiosConfig(PATHS.CCB_URL, true, {
    'Content-Type': 'application/json',
    'mmt-auth': getCookie('mmt-auth'),
}, false);

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

import { setApiError, setApiLoading, setApiSuccess } from "./expenseActions";

export const addTimeStamp = (params) => {
    const tempParams = {...params};
    try {
        if(tempParams.startDate) {
            tempParams.startDate = new Date(tempParams.startDate).setHours(0);
            tempParams.startDate = new Date(tempParams.startDate).setMinutes(0);
            tempParams.startDate = new Date(tempParams.startDate).setSeconds(0);
        }
        if(tempParams.endDate) {
            tempParams.endDate = new Date(tempParams.endDate).setHours(23);
            tempParams.endDate = new Date(tempParams.endDate).setMinutes(59);
            tempParams.endDate = new Date(tempParams.endDate).setSeconds(59);
        }
    } catch (error) {
        
    }
    
    return tempParams;
}

export const getExpenselist = (sendData, isScroll, noRefresh) => async (dispatch) => {
    let apiError = false;
    try {
        if(!noRefresh) {
            dispatch(listApiCalling({ isScroll }));
        }
        let resp = null;
        resp = await axiosApiCaller.post(PATHS.GET_EXPENSE_LIST, addTimeStamp(sendData))

        const {
            data = {}
        } = resp;
        if (data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            dispatch({
                type: EXPENSE_REIMBURSE_CONST.GET_LIST,
                payload: { data, isScroll }
            })
          
        } else {
            apiError = true;
        }

    } catch (e) {
        apiError = true;
        saveServerLogs(e.stack, 'error', PATHS.GET_EXPENSE_LIST);
    } finally {
        if (apiError) {
            dispatch(listApifailed());
        }
    }
};

export const getExpenseCounts = (sendData, isScroll) => async (dispatch) => {
    let apiError = false;
    try {
        let resp = null;
        resp = await axiosApiCaller.post(PATHS.GET_EXPENSE_COUNTS, addTimeStamp(sendData))

        const {
            data = {}
        } = resp;
        if (data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            dispatch({
                type: EXPENSE_REIMBURSE_CONST.GET_FILTER_COUNTS,
                payload: { data }
            })
          
        } else {
            apiError = true;
        }

    } catch (e) {
        apiError = true;
        saveServerLogs(e.stack, 'error', PATHS.GET_EXPENSE_LIST);
    }
};

export const listApiCalling = (payload) => ({
    type: EXPENSE_REIMBURSE_CONST.GET_LIST_CALLING,
    payload
});

export const listApifailed = (payload) => ({
    type: EXPENSE_REIMBURSE_CONST.GET_LIST_FAILED,
    payload
});

export const setSelected = (payload) => ({
    type: EXPENSE_REIMBURSE_CONST.UPDATE_SELECTED,
    payload
});

export const updateFilters = (payload) => ({
    type: EXPENSE_REIMBURSE_CONST.UPDATE_FILTER_DATA,
    payload
});

export const updateFilterQuery = (payload) => ({
    type: EXPENSE_REIMBURSE_CONST.UPDATE_FILTER_QUERY,
    payload
});

export const downloadCSV = (apiRequest, isPending) => async dispatch => {
    let response = null;
    dispatch(setApiLoading('startDwlExp'))
    let error = false;
    try {
        response = await axiosApiCaller.post(PATHS.EXPENSE_CSV_DWL, apiRequest);
        if (response.data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE && response.data.downloadReportId) {
            dispatch(setApiLoading(false))
            window.open(PATHS.CCB_URL+ PATHS.EXPENSE_DWLD_URL+response.data.downloadReportId + `&isPending=${isPending}`);
        } else {
            error = true;
        }

    } catch (e) {
        error = true
        saveServerLogs(e.stack, 'error', PATHS.DOWNLOAD_INVOICE);
    } finally {
        if(error) {
            dispatch(setApiError())
        }
    }
};

export const uploadCSv = (apiRequest) => async dispatch => {
    let response = null;
    dispatch(setApiLoading('startuploadExp'));
    const axiosUploadApiCaller = getAxiosConfig(PATHS.CCB_URL, true, {
        'Content-Type': 'multipart/form-data',
        'mmt-auth': getCookie('mmt-auth'),
    }, false);
    let error = false;
    try {
        response = await axiosUploadApiCaller.post(PATHS.EXPENSE_UPLOAD, apiRequest, { cancelToken: source.token });
        if (response.data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            dispatch({
                type: EXPENSE_REIMBURSE_CONST.UPLOAD_SUCCESS,
                payload: response.data.count
            })
        } else {
            error = true;
        }
    } catch (e) {
        error = e.message !== 'Operation canceled by the user.';
        saveServerLogs(e.stack, 'error', PATHS.DOWNLOAD_INVOICE);
    } finally {
        if(error) {
            dispatch(setApiError({ openModal: false, type: 'uploadErr' }));
        } else {
            dispatch(setApiLoading(false));
        }
    }
};

export const reimburseById = (apiRequest, isDetail) => async dispatch => {
    let response = null;
    dispatch(setApiLoading('startReimb'));
    let error = false;
    try {
        response = await axiosApiCaller.put(PATHS.EXPENSE_REIMBBYID, apiRequest);
        if (response.data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            dispatch({
                type: EXPENSE_REIMBURSE_CONST.UPLOAD_SUCCESS,
                payload: apiRequest.length
            });
            if(isDetail) {
                window.history.back();
            }
        } else {
            error = true;
        }
    } catch (e) {
        saveServerLogs(e.stack, 'error', PATHS.DOWNLOAD_INVOICE);
    } finally {
        if(error) {
            dispatch(setApiError())
        } else {
            dispatch(setApiLoading(false));
        }
    }
};


export const cancelUpload = () => dispatch => {
    source.cancel('Operation canceled by the user.');
    dispatch(setApiLoading('startuploadExp'));
    dispatch({
        type: EXPENSE_REIMBURSE_CONST.CANCEL_UPLOAD,
    });
}

export const setModal = (payload) => ({
    type: EXPENSE_REIMBURSE_CONST.SET_MODAL,
    payload
});

export const getSearchExpenselist = (sendSearchData, isScroll) => async (dispatch) => {
    let apiError = false;
    try {
        dispatch({
            type: EXPENSE_REIMBURSE_CONST.SEARCH_LIST_CALLING,
            payload: { isScroll,  sendSearchData}
        });
        let resp = null;
        resp = await axiosApiCaller.post(PATHS.SEARCH_EXPENSE, sendSearchData)

        const {
            data = {}
        } = resp;
        if (data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
            dispatch({
                type: EXPENSE_REIMBURSE_CONST.SEARCH_LIST_SUCCESS,
                payload: { data, isScroll }
            })
            return;
          
        } 
        apiError = true;

    } catch (e) {
        apiError = true;
        saveServerLogs(e.stack, 'error', PATHS.SEARCH_EXPENSE);
    } finally {
        if (apiError) {
            dispatch({
                type: EXPENSE_REIMBURSE_CONST.SEARCH_LIST_FAILED
            });
        }
    }
};

export const resetSearchError = () => ({
    type:EXPENSE_REIMBURSE_CONST.SEARCH_LIST_RESET
})

export const startBulkDownload = (id) =>  {
    let url = PATHS.BULK_REPORT_DOWNLOD.replace('{jobId}', id);
    window.open(PATHS.CCB_URL+ url);
};

export const bulkDwlExps = (apiRequest) => async dispatch => {
    let response = null;
    let apiError = false;
    let apiSuccess = false;
    dispatch(setApiLoading('startbulkDwlExp'))
    try {
        response = await axiosApiCaller.post(PATHS.DOWNLOAD_TNE_REPORT, apiRequest);
        const resData = response.data;
        if (resData && resData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE && resData.jobId) {
            const { jobId, sendEmail, actualCount, maxCount} = resData;
            if (!sendEmail) {
                startBulkDownload(jobId);
            }
            dispatch({
                type: EXPENSE_REIMBURSE_CONST.DOWNLOAD_TnE,
                payload: {
                    sendEmail,
                    actualCount,
                    maxCount,
                }
            })
        } else if(resData.responseCode === APPLICATION_CONSTANTS.ALERT_RESPONSE_CODE && resData.isAlreadySent) {
            apiSuccess = true;
            dispatch(setApiSuccess({
                title: resData.heading,
                desc: resData.content,
                btnTxt: 'OK'
            }));
        } else {
            apiError = true;
        }

    } catch (e) {
        apiError = true;
        saveServerLogs(e.stack, 'error', PATHS.DOWNLOAD_TNE_REPORT);
    } finally {
        if(apiError) {
            dispatch(setApiError())
        } else if(!apiSuccess) {
            dispatch(setApiLoading(false));
        }
    }
};

export const emailExpenses =  apiRequest => async dispatch => {
    let apiError = false;
    try {
        dispatch(setApiLoading('startbulkDwlExp'))
        await axiosApiCaller.post(PATHS.DOWNLOAD_TNE_REPORT, apiRequest);
    } catch (e) {
        saveServerLogs(e.stack, 'error', PATHS.DOWNLOAD_TNE_REPORT);
        apiError = true;
    } finally {
        if(apiError) {
            dispatch(setApiError())
        } else {
            dispatch(setApiLoading(false));
        }
    }
};
